import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import developer from '../../JsonData/developer.json';
import { slugify } from '../../utils/slugify';

const DeveloperList = () => {
  const [developerList, setDeveloperList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setDeveloperList(developer.developerData); // load from JSON
  }, []);

  // Filter developers by search term
  const filteredDevelopers = developerList.filter((dev) =>
    dev.developername.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container py-5">
      <style>{`
        .developer-card {
          border: 1px solid #eee;
          border-radius: 15px;
          overflow: hidden;
          background-color: #fff;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          gap: 20px;
        }

        .developer-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        }

        .developer-image-wrapper {
          position: relative;
          height: 200px;
          overflow: hidden;
        }

        .developer-image-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .developer-logo {
          position: absolute;
          bottom: 10px;
          left: 10px;
          background-color: #fff;
          padding: 6px 12px;
          border-radius: 6px;
          max-height: 40px;
        }

        .developer-logo img {
          max-height: 100px;
          max-width: 100px;
        }

        .developer-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-top: 15px;
        }

        .developer-desc {
          font-size: 0.95rem;
          color: #6c757d;
          margin-top: 8px;
        }

        .search-bar {
          width: 100%;
          max-width: 400px;
          margin-bottom: 30px;
          padding: 10px 16px;
          border: 1px solid #ccc;
          border-radius: 8px;
          font-size: 16px;
        }
      `}</style>

      <div style={{ paddingTop: "20px", paddingBottom: "25px" }}>
        <h2 style={{ fontSize: "35px", textAlign:"center" }}>
          <strong>Leading Real Estate Developers in Dubai</strong>
        </h2>
      </div>

     <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px' }}>
  <input
    type="text"
    className="search-bar"
    placeholder="Search Developer by Name..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>


      <div className="row">
        {filteredDevelopers.length > 0 ? (
          filteredDevelopers.map((item) => (
            <div className="col-lg-4 col-md-6 mb-4" key={item.ID}>
              <Link to={`/developername/dubai/${slugify(item.developername)}`}>
                <div className="developer-card h-100">
                  <div className="developer-image-wrapper">
                    <img src={item.image} alt={item.developername} />
                    <div className="developer-logo">
                      <img src={item.logo} alt={`${item.developername} logo`} />
                    </div>
                  </div>
                  <div className="developer-title mt-3 px-3">{item.developername} Properties</div>
                  <div className="developer-desc px-3 py-3">
                    {item.descripetion.length > 100
                      ? item.descripetion.slice(0, 100) + '...'
                      : item.descripetion}
                  </div>
                </div>
              </Link>
            </div>
          ))
        ) : (
          <div className="col-12">
            <p>No developers found.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeveloperList;
